import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { Surface, Text, IconButton, useTheme } from 'react-native-paper';
import { useAuth } from '../contexts/AuthContext';
import { useTheme as useAppTheme } from '../contexts/ThemeContext';
import { useNavigation } from '@react-navigation/native';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';

interface AppHeaderProps {
  title?: string;
  showBack?: boolean;
}

export const AppHeader: React.FC<AppHeaderProps> = ({ 
  title = 'Transmission Asset Network System',
  showBack = false 
}) => {
  const theme = useTheme();
  const { toggleTheme, isDarkMode } = useAppTheme();
  const { logout } = useAuth();
  const navigation = useNavigation();

  return (
    <Surface style={[styles.header, { backgroundColor: theme.colors.elevation.level2 }]} elevation={4}>
      <View style={styles.headerContent}>
        <View style={styles.leftSection}>
          {showBack && (
            <IconButton
              icon="arrow-left"
              size={24}
              onPress={() => navigation.goBack()}
              style={styles.backButton}
              iconColor={theme.colors.primary}
            />
          )}
          <MaterialCommunityIcons
            name="transmission-tower"
            size={24}
            color={theme.colors.primary}
            style={styles.logo}
          />
          <Text variant="headlineSmall" style={[styles.title, { color: theme.colors.onSurface }]}>
            {title}
          </Text>
        </View>
        
        <View style={styles.rightSection}>
          <IconButton
            icon={isDarkMode ? 'weather-sunny' : 'weather-night'}
            size={24}
            onPress={toggleTheme}
            iconColor={theme.colors.primary}
          />
          <IconButton
            icon="logout"
            size={24}
            onPress={logout}
            iconColor={theme.colors.error}
          />
        </View>
      </View>
    </Surface>
  );
};

const styles = StyleSheet.create({
  header: {
    height: Platform.OS === 'web' ? 64 : 56,
    justifyContent: 'center',
  },
  headerContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
  },
  leftSection: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  rightSection: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  backButton: {
    marginRight: 8,
  },
  logo: {
    marginRight: 12,
  },
  title: {
    fontWeight: '500',
  },
});
